<template>
  <ui-dropdown-menu>
    <ui-dropdown-menu-trigger as-child :disabled="disabled">
      <button
        type="button"
        data-slot="lead-status-select"
        :aria-label="tr('Status') + ': ' + current.label"
        :class="[
          'inline-flex h-8 min-w-32 items-center justify-between gap-2 rounded-md px-2.5 text-xs font-semibold tracking-wide uppercase transition-opacity',
          current.chip,
          disabled ? 'cursor-default opacity-70' : 'cursor-pointer hover:opacity-85',
        ]"
        @click.stop
      >
        {{ current.label }}
        <loader-circle-icon v-if="loading" class="size-3.5 animate-spin" />
        <chevron-down-icon v-else-if="!disabled" class="size-3.5" />
      </button>
    </ui-dropdown-menu-trigger>
    <ui-dropdown-menu-content align="start" class="w-44" @click.stop>
      <ui-dropdown-menu-radio-group :model-value="modelValue" @update:model-value="(value) => select(value)">
        <ui-dropdown-menu-radio-item v-for="option in options" :key="option.value" :value="option.value">
          <template #indicator-icon>
            <check-icon class="size-3.5" />
          </template>
          <span :class="[ 'size-2 rounded-full', option.dot ]" />
          {{ option.label }}
        </ui-dropdown-menu-radio-item>
      </ui-dropdown-menu-radio-group>
    </ui-dropdown-menu-content>
  </ui-dropdown-menu>
</template>

<script>
import { Check, ChevronDown, LoaderCircle } from '@lucide/vue';

import { leadStatusOptions } from '@/ui/utils/leadStatus.js';

export default {
  name: 'LeadStatusSelect',
  components: {
    CheckIcon: Check,
    ChevronDownIcon: ChevronDown,
    LoaderCircleIcon: LoaderCircle,
  },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: [ 'update:modelValue' ],
  computed: {
    options() {
      return leadStatusOptions(this.tr);
    },
    current() {
      return this.options.find(option => option.value === this.modelValue) ?? this.options[0];
    },
  },
  methods: {
    select(value) {
      if (value && value !== this.modelValue) {
        this.$emit('update:modelValue', value);
      }
    },
  },
};
</script>
